import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet User Info',
  path: '/homenet/userinfo',
  redirect: '/homenet/userinfo/info',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'Info',
      'path': 'info',
      'meta': {
        'label': 'Info'
      },
      'component': lazyLoading('homenet/UserInfo')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/userinfo.js